import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <section className="wrap empty" style={{ paddingTop: 120 }}>
      <span className="eyebrow">404</span>
      <h1 style={{ fontSize: 56, letterSpacing: "-0.04em" }}>Out of the money.</h1>
      <p>This page expired worthless.</p>
      <Link to="/" className="btn btn-primary">Back home</Link>
    </section>
  );
}
